import { render, staticRenderFns } from "./staffSnapshotList.vue?vue&type=template&id=4930e79e"
import script from "./staffSnapshotList.vue?vue&type=script&lang=js"
export * from "./staffSnapshotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports